import { Injectable } from '@angular/core';

@Injectable()
export class MarketingPromptBuilder {
  build(s: string): string {
    return `Write a paragraph for a marketing email based on the following prompt: ${s}`;
  }
}
